import { render } from "./AfterSalesList.vue?vue&type=template&id=331ad90e&scoped=true"
import script from "./AfterSalesList.vue?vue&type=script&lang=js"
export * from "./AfterSalesList.vue?vue&type=script&lang=js"

import "./AfterSalesList.vue?vue&type=style&index=0&id=331ad90e&lang=scss&scoped=true"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331ad90e"]])

export default __exports__